const KEY = "fcg_intake_draft";
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export const loadDraft = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const draft = JSON.parse(raw);
    if (!draft || !draft.ts || Date.now() - draft.ts > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return draft;
  } catch {
    return null;
  }
};

export const saveDraft = ({ enquiryId, form, step, platformName, isSocial }) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ enquiryId, form, step, platformName, isSocial, ts: Date.now() }));
  } catch {
    /* storage unavailable — ignore */
  }
};

export const clearDraft = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};
